/** Matches word tokens not followed by '(' — those are function calls, not variables. */
export const VARIABLE_RE = /\b([a-zA-Z][a-zA-Z0-9_]*)\b(?!\s*\()/g;

/** Returns unique variable names found in a formula expression, in order of first appearance. */
export function extractFormulaVariables(formula: string): string[] {
  const re = new RegExp(VARIABLE_RE.source, 'g');
  const seen = new Set<string>();
  let match: RegExpExecArray | null;
  while ((match = re.exec(formula)) !== null) {
    seen.add(match[1]);
  }
  return [...seen];
}
